var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pageLoading
        ? _c("div", { staticClass: "spinner-background" }, [
            _c("div", { staticClass: "spinner" })
          ])
        : [
            _c("router-view", { attrs: { translations: _vm.translations } }),
            _vm._v(" "),
            _c("modals-container")
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }